/** Chinese text: dashboard, kids, family, notifications, approvals, audit, devices. See ../portalZh.ts. */
export const ZH_FAMILY: Readonly<Record<string, string>> = {
  "Today's picks": '今日推荐',
  'See everything in Explore': '在探索中查看全部',
  'Hangar memory': 'Hangar 记忆',
  'Choose whose memory to manage': '选择要管理谁的记忆',
  'My memory': '我的记忆',
  'Could not load your children.': '无法加载你的孩子。',
  'Payment open': '待付款',
  'Course place': '课程名额',
  'Finish checkout to lock the seat.': '完成结账即可锁定名额。',
  'Resume checkout': '继续结账',
  'Family items not assigned to a kid': '未分配给孩子的家庭事项',
  'Not assigned to a current kid': '未分配给当前孩子',
  'View {count} more': '再查看 {count} 项',
  'Creative studios': '创作空间',
  'Create, learn & explore': '创作、学习与探索',
  '{count} creative spaces': '{count} 个创作空间',
  'Your child can explore ideas and make their own games, art, stories, music and films in Learn. You can use every studio yourself. Your creations stay in your parent account, separate from your child’s work.':
    '孩子可以在 Learn 中探索创意，做出自己的游戏、画作、故事、音乐和影片。你也可以亲自使用每个创作空间。你的作品保存在家长账户中，与孩子的作品分开。',
  'Ready-made story adventures to read, listen and explore with your child.':
    '现成的故事冒险，可以和孩子一起阅读、聆听和探索。',
  'Explore stories →': '探索故事 →',
  'Create as a parent →': '以家长身份创作 →',
  'Explore {title} example': '查看 {title} 示例',
  'Explore a finished example ↗': '查看完成的示例 ↗',
  'Help my child sign in to Learn ↑': '帮孩子登录 Learn ↑',
  'Examples use pre-made, isolated demo content. For your child’s own creations, use their Learn sign-in in the family section above. AI actions may use Stars; costs appear before use.':
    '示例使用预先制作、相互隔离的内容。要查看孩子自己的作品，请使用上方家庭区域中的 Learn 登录。AI 操作可能会消耗星星，使用前会显示费用。',
  'Continue my saved projects →': '继续我保存的项目 →',
  'That nickname is already used in your family — pick a new one below.':
    '这个昵称已被家里其他孩子使用，请在下方换一个。',
  "That kid code doesn't match — check it with the teacher and try again.":
    '孩子代码不匹配，请向老师确认后重试。',
  'Could not claim the kid — try again.': '无法认领这个孩子，请重试。',
  'Got a kid code from an Airbotix workshop? Enter it here to add that kid — and everything they made — to your family.':
    '从 Airbotix 工作坊拿到了孩子代码？在这里输入，就能把这个孩子和 TA 做过的所有作品加入你的家庭。',
  'Kid code': '孩子代码',
  'New 4-digit PIN': '新的 4 位 PIN',
  Age: '年龄',
  Nickname: '昵称',
  '(pick a new one)': '（请换一个）',
  '(optional — keeps the workshop one)': '（选填，不填则沿用工作坊昵称）',
  'Claiming…': '认领中…',
  'Claim my kid →': '认领我的孩子 →',
  'That looks too short': '太短了',
  'Letters and numbers only': '只能使用字母和数字',
  'Airbotix is for ages 6+': 'Airbotix 适合 6 岁及以上',
  '4 digits': '4 位数字',
  "Airbotix Hangar is the desktop app where children aged 12+ build with an AI helper. Pair a computer from Hangar, then set each child's rules here.":
    'Airbotix Hangar 是桌面应用，12 岁以上的孩子可以在其中与 AI 助手一起创作。先在 Hangar 中配对电脑，再在这里为每个孩子设置规则。',
  'Pair with a code': '用配对码配对',
  'Manage memory': '管理记忆',
  'Paired computers': '已配对的电脑',
  'Could not load your computers.': '无法加载你的电脑。',
  'Could not remove this computer.': '无法移除这台电脑。',
  'No computer is paired yet.': '还没有配对任何电脑。',
  '{os} · Hangar {version} · last used {time}': '{os} · Hangar {version} · 上次使用 {time}',
  'Removing…': '移除中…',
  'Remove now': '立即移除',
  Keep: '保留',
  'Remove computer': '移除电脑',
  'Rules for each child': '每个孩子的规则',
  Paused: '已暂停',
  'Loading rules…': '正在加载规则…',
  'Could not load the rules.': '无法加载规则。',
  'Rules for {name}': '{name} 的规则',
  Strict: '严格',
  Standard: '标准',
  Independent: '自主',
  'Helper message': '助手消息',
  Lesson: '课节',
  Time: '时间',
  Project: '项目',
  'Minutes a day': '每天分钟数',
  'Stars a day': '每天星星数',
  'Pause the helper for {name}': '暂停 {name} 的助手',
  'Could not save the rules.': '无法保存规则。',
  'Saved.': '已保存。',
  'Saving…': '保存中…',
  'Save rules': '保存规则',
  'Recent Hangar activity': 'Hangar 近期活动',
  'Could not load activity.': '无法加载活动。',
  'No activity yet.': '暂无活动。',
  'Run a command': '运行命令',
  'Install a package': '安装软件包',
  'Make a picture or song': '制作图片或歌曲',
  'Make a video': '制作视频',
  'Open a website': '打开网站',
  'Share a project': '分享项目',
  'Pause now': '立即暂停',
  'End for today': '今天到此为止',
  'Lock on this computer': '在这台电脑上锁定',
  Unlock: '解锁',
  'Paused. Hangar signs your child out within a few seconds.':
    '已暂停。Hangar 会在几秒内让孩子退出登录。',
  'Done. The helper stays off until tomorrow.': '完成。助手今天不会再开启，明天恢复。',
  'Locked on this computer.': '已在这台电脑上锁定。',
  'Unlocked.': '已解锁。',
  'Your child': '你的孩子',
  'Waiting for you': '等你处理',
  'Could not load requests.': '无法加载请求。',
  'Could not answer this request.': '无法回复这条请求。',
  'Nothing to approve right now.': '目前没有需要审批的内容。',
  'Do something': '做点什么',
  '{name} wants to {action}:': '{name} 想要{action}：',
  'Expires {time}': '到期时间 {time}',
  'Allow once': '允许一次',
  'Always allow this': '始终允许',
  'Say no': '拒绝',
  'Right now': '此刻',
  Computer: '电脑',
  'Could not send this to the computer.': '无法发送到电脑。',
  'Last 7 days': '最近 7 天',
  'Could not load the report.': '无法加载报告。',
  '{count} helper messages': '{count} 条助手消息',
  '{count} Stars': '{count} 颗星星',
  '{count} minutes': '{count} 分钟',
  '{count} projects': '{count} 个项目',
  '{count} lessons': '{count} 个课节',
  '{count} safety alerts': '{count} 条安全提醒',
  'What {name} asked the helper': '{name} 向助手问了什么',
  'Could not load messages.': '无法加载消息。',
  'No messages yet.': '暂无消息。',
  'Safety alert': '安全提醒',
  'Only a parent account can pair a Hangar computer.': '只有家长账户才能配对 Hangar 电脑。',
  'Computer paired': '电脑已配对',
  '{name} is now linked to your family. Hangar finishes the setup by itself in a few seconds.':
    '{name} 已与你的家庭关联。Hangar 会在几秒内自动完成设置。',
  'The computer': '这台电脑',
  'Manage Hangar computers': '管理 Hangar 电脑',
  'Pair a Hangar computer': '配对 Hangar 电脑',
  'Enter the 6-digit code that Hangar shows on the computer.':
    '输入 Hangar 在电脑上显示的 6 位数字码。',
  'Pairing code': '配对码',
  'Looking up the computer…': '正在查找这台电脑…',
  'That code is not valid or has expired.': '这个配对码无效或已过期。',
  'Children who can use this computer': '可以使用这台电脑的孩子',
  "I am this family's parent or guardian. I agree that my children can use the Hangar AI helper on this computer, that it uses our family Stars, and that their helper messages are checked for safety and shown to me.":
    '我是这个家庭的家长或监护人。我同意孩子在这台电脑上使用 Hangar AI 助手，同意它消耗我们家庭的星星，并同意对孩子与助手的消息进行安全检查并展示给我。',
  'Could not pair this computer.': '无法配对这台电脑。',
  'Pairing…': '配对中…',
  'Pair this computer': '配对这台电脑',
  'Last 28 days': '最近 28 天',
  'Creative days': '创作天数',
  '1 day': '1 天',
  '{count} days': '{count} 天',
  "{name}'s creative days over the last 28 days": '{name} 最近 28 天的创作天数',
  '{date}: 1 activity': '{date}：1 次活动',
  '{date}: {count} activities': '{date}：{count} 次活动',
  'Activity intensity scale': '活跃程度图例',
  Quiet: '较少',
  'Level {level}': '等级 {level}',
  'Creative interests': '创作兴趣',
  'What {name} explored': '{name} 探索了什么',
  "{name}'s studio activity split: {split}": '{name} 的创作空间活动占比：{split}',
  '{label} {percent} percent': '{label} {percent}%',
  studios: '个创作空间',
  'Loading activities…': '正在加载活动…',
  "We couldn't load these activities": '无法加载这些活动',
  'Check your connection, then try again.': '请检查网络连接后重试。',
  'Back to Home': '返回首页',
  'Family Apps': '家庭应用',
  'Paid with family Stars': '使用家庭星星支付',
  'Exit demo mode': '退出体验模式',
  'See the demo': '查看 Demo',
  'You are looking at the Airbotix demo family, Mia and Leo. Try anything: nothing is charged or saved.':
    '你正在体验 Airbotix 的 Demo 家庭（Mia 和 Leo）。可以随便操作：不会扣星，也不会保存。',
  'Coming soon. This app is not open yet.': '即将推出，这个应用暂未开放。',
  'App not found': '找不到这个应用',
  'We could not find this app. It may have moved or is no longer available.':
    '找不到这个应用。它可能已经移动，或者已经下线。',
  "Could not open {name}'s kids page. Please try again.": '无法打开 {name} 的孩子页面，请重试。',
  Active: '活跃',
  "{name}'s activities": '{name} 的活动',
  '{name} made {creations} across {days} in the last four weeks.':
    '最近四周，{name} 在 {days}里创作了 {creations}。',
  '1 creation': '1 件作品',
  '{count} creations': '{count} 件作品',
  '1 active day': '1 个活跃日',
  '{count} active days': '{count} 个活跃日',
  "Open {name}'s kids page": '打开 {name} 的孩子页面',
  'Opening…': '正在打开…',
  "Open {name}'s page": '打开 {name} 的页面',
  "View {name}'s learning support report": '查看 {name} 的学习支持报告',
  'Study report': '学习报告',
  "Edit {name}'s profile": '编辑 {name} 的资料',
  'Profile & PIN': '资料与 PIN',
  "View {name}'s Art Studio pictures": '查看 {name} 的 Art Studio 画作',
  'Art Studio pictures': 'Art Studio 画作',
  'Loading activity overview': '正在加载活动概览',
  'Activity overview is unavailable': '暂时无法显示活动概览',
  'Recent projects are still available below.': '下方仍可查看最近的项目。',
  'Ready for a first activity': '准备好第一次活动了',
  'Once {name} signs in and starts a project, this page will show active days, creative interests and finished work.':
    '{name} 登录并开始一个项目后，这里会显示活跃天数、创作兴趣和完成的作品。',
  'Family code': '家庭代码',
  Copied: '已复制',
  'Copy code': '复制代码',
  'Activity summary': '活动概览',
  Creations: '作品数',
  'Active days': '活跃天数',
  'Creative minutes': '创作分钟数',
  Sessions: '学习次数',
  'The activity rhythm chart is unavailable.': '暂时无法显示活动节奏图表。',
  'Retry chart': '重新加载图表',
  'Recent work': '近期作品',
  'What {name} made': '{name} 做了什么',
  'All projects': '全部项目',
  'Projects are unavailable right now.': '项目暂时无法显示。',
  'No projects yet': '还没有项目',
  'Start creating': '开始创作',
  'Recently edited': '最近编辑',
  'Edited today': '今天编辑',
  'Edited yesterday': '昨天编辑',
  Website: '网站',
  Chatbot: '聊天机器人',
  'Code project': '代码项目',
  'Creative project': '创意项目',
  'Explore the evidence': '查看成果记录',
  'Creator Passport': '创作护照',
  'Art Studio': 'Art Studio',
  'Music studio': '音乐创作室',
  'Voice booth': '配音间',
  'Video studio': '视频创作室',
  'Code lab': '代码实验室',
  'Game studio': '游戏创作室',
  Chat: '聊天',
  Missions: '任务',
  'Today, {time}': '今天 {time}',
  'Yesterday, {time}': '昨天 {time}',
  '{count} days ago, {time}': '{count} 天前 {time}',
  '{date}, {time}': '{date} {time}',
  'a project': '一个项目',
  'Continued “{title}”': '继续了“{title}”',
  'Started “{title}”': '开始了“{title}”',
  'Latest prompt': '最新提示词',
  'Saved new work in {studio}': '在 {studio} 保存了新作品',
  'New project in {studio}': '在 {studio} 新建了项目',
  'Prompt used in {studio}': '在 {studio} 使用的提示词',
  "View {name}'s activities": '查看 {name} 的活动',
  'See history': '查看历史',
  'Recent prompt · {studio}': '近期提示词 · {studio}',
  'See all prompts used by {name}': '查看 {name} 用过的全部提示词',
  'All prompts': '全部提示词',
  'Saved {title}': '保存了 {title}',
  'Started {title}': '开始了 {title}',
  'Creative history': '创作历史',
  'What {name} did': '{name} 做了什么',
  'Activity history filter': '活动历史筛选',
  'All activity': '全部活动',
  'Prompts only': '仅提示词',
  'Loading creative history': '正在加载创作历史',
  "{name}'s prompt history": '{name} 的提示词历史',
  "{name}'s creative history": '{name} 的创作历史',
  'Load older activity': '加载更早的活动',
  'Pre-made AI fantasy film example': '预先制作的 AI 奇幻短片示例',
  'AI film example · Pre-made': 'AI 短片示例 · 预先制作',
  'Studio recording · Pre-written stories': '创作空间录屏 · 预先写好的故事',
  'Real Studio · Example recording': '真实创作空间 · 示例录屏',
  'AI film example': 'AI 短片示例',
  '{title} recording': '{title} 录屏',
  '{id} real Studio example recording': '{id} 真实创作空间示例录屏',
  'Video unavailable. Please reload to try again.': '视频无法播放，请刷新页面后重试。',
  'Pause {label}': '暂停 {label}',
  'Play {label}': '播放 {label}',
  'Pause · Silent': '暂停 · 静音',
  'Play · Silent': '播放 · 静音',
  'Add a child': '添加孩子',
  'Dismiss this reminder': '关闭此提醒',
  'Next step: add your child': '下一步：添加你的孩子',
  'Create a child profile so your child can start making things with Airbotix.':
    '创建孩子的档案，孩子就能开始用 Airbotix 创作。',
  'Next step: start a first creation': '下一步：开始第一次创作',
  'Make a first game or story. It takes a few minutes.': '做出第一个游戏或故事，只需几分钟。',
  'Your child can make a first game or story in a few minutes. Open a studio to begin.':
    '孩子几分钟就能做出第一个游戏或故事。打开一个创作空间开始吧。',
  'Open a studio': '打开创作空间',
  'Next step: see classes you can book': '下一步：查看可预约的班级',
  'Browse the classes and pick a time that suits you.': '浏览班级，选一个适合你的时间。',
  'Browse the classes and pick a time that suits your family.':
    '浏览班级，选一个适合你们家庭的时间。',
  'See classes': '查看班级',
  'You joined a few days ago and have not added a child yet. Add a profile when you are ready.':
    '你几天前加入了 Airbotix，还没有添加孩子。准备好时添加孩子的档案即可。',
  'You have not made anything yet. A first creation takes a few minutes.':
    '你还没有做过任何作品。第一次创作只需几分钟。',
  'Your child has not made anything yet. A first creation takes a few minutes.':
    '孩子还没有做过任何作品。第一次创作只需几分钟。',
  Featured: '精选',
  'Matching games': '符合条件的游戏',
  'All games': '全部游戏',
  'Loading games…': '正在加载游戏…',
  'We couldn’t load the games.': '无法加载游戏。',
  'Show more games': '显示更多游戏',
  'No games here yet.': '这里还没有游戏。',
  'Some games are made by the Airbotix team to inspire you.':
    '部分游戏由 Airbotix 团队制作，希望带给你灵感。',
  'Play {title} by {name}': '玩 {name} 制作的《{title}》',
  "Illustrative photo for {name}'s fictional learner story": '{name} 的学习者故事配图',
  'Stock photo · Fictional learner story': '图库照片 · 学习者故事',
  'Default illustrated creator avatar': '默认插画创作者头像',
  'by {name}': '作者：{name}',
  'Example learner story': '学习者故事示例',
  'Ages {range}': '{range} 岁',
  claps: '个赞',
  '{title} by {name}': '{name} 的《{title}》',
  'View course: {title}': '查看课程：{title}',
  'View course': '查看课程',
  Clapped: '已点赞',
  Clap: '点赞',
  Exit: '退出',
  '{title} game': '{title} 游戏',
  'This game can’t open here yet.': '这个游戏暂时无法在这里打开。',
  'Filter by age': '按年龄筛选',
  'Filter by kind': '按类型筛选',
  'All ages': '全部年龄',
  'Ages 5-7': '5-7 岁',
  'Ages 8-10': '8-10 岁',
  'Ages 11-13': '11-13 岁',
  'Ages 14+': '14 岁以上',
  'All kinds': '全部类型',
  Games: '游戏',
  Websites: '网站',
  Code: '代码',
  Creative: '创意',
  Chatbots: '聊天机器人',
  'Game not working?': '游戏打不开？',
  'Sending…': '发送中…',
  'Thanks! We’ll take a look.': '谢谢！我们会去查看。',
  'Couldn’t send. Try again.': '发送失败，请重试。',
  'This game is no longer here.': '这个游戏已经不在这里了。',
  'See what others made': '看看别人做了什么',
  'What kids make on Airbotix': '孩子们在 Airbotix 做出的作品',
  'Examples from our Student Work gallery. In this course your child builds a game of their own.':
    '来自学员作品展的示例。在这门课程中，孩子会做出一个自己的游戏。',
  'Games and projects from other kids on Airbotix.': 'Airbotix 上其他孩子的游戏和项目。',
  'See all →': '查看全部 →',
  'Real studio preview': '真实创作空间预览',
  'Try {title} yourself — free demo': '亲自试试 {title}，免费体验',
  'Try {title} yourself': '亲自试试 {title}',
  'No sign-in · no Stars · nothing saved': '无需登录 · 不消耗星星 · 不保存任何内容',
  'Open demo ↗': '打开体验 ↗',
  'Real preview available': '可查看真实预览',
  "Creating here needs your child's Learn sign-in. We do not show a pretend demo.":
    '在这里创作需要孩子的 Learn 登录。我们不会展示虚假的演示。',
  'What your child does': '孩子会做什么',
  'What they practise': '练习的能力',
  'AI and Stars': 'AI 与星星',
  'Featured classic journey': '精选经典旅程',
  'Ask them afterwards': '事后可以问问孩子',
  'Good fit for': '适合谁',
  'What they can make': '可以做出什么',
  'See the parent guide': '查看家长指南',
  'Hide the parent guide': '收起家长指南',
  'Find it: {path}': '入口：{path}',
  'Which creative space fits your child?': '哪个创作空间适合你的孩子？',
  'Swipe to compare studios →': '左右滑动对比创作空间 →',
  'Need to get your child into Learn?': '需要让孩子进入 Learn？',
  "Home keeps each child's sign-in and profile controls together.":
    '首页集中管理每个孩子的登录和资料设置。',
  'Go to Family →': '前往家庭 →',
  'Ages 5–8 · Free': '5–8 岁 · 免费',
  'Ages 8–14': '8–14 岁',
  'Draw + AI': '绘画 + AI',
  'Compose + record': '作曲 + 录音',
  'AI filmmaking · Guided Director': 'AI 电影制作 · 导演引导',
  'Coming soon': '即将推出',
  'Learn home → Story Blocks': 'Learn 首页 → Story Blocks',
  'Learn home → Creative Code Studio': 'Learn 首页 → Creative Code Studio',
  'Learn home → Website Studio': 'Learn 首页 → Website Studio',
  'Learn home → Chatbot Studio': 'Learn 首页 → Chatbot Studio',
  'Learn home → Art Studio': 'Learn 首页 → Art Studio',
  'Learn home → Music Stage': 'Learn 首页 → Music Stage',
  'Learn home → Video Studio': 'Learn 首页 → Video Studio',
  'Not yet available': '暂未开放',
  'A storybook your child programs with picture blocks — no typing needed.':
    '孩子用图形积木给故事书编程，无需打字。',
  'Ideas become interactive creations with AI and real JavaScript to inspect and improve.':
    '借助 AI 和真实的 JavaScript，把想法变成可互动的作品，并能查看和改进代码。',
  'Your child builds a real multi-page website — pages, styles and a little backend they can read and change.':
    '孩子搭建一个真实的多页面网站：页面、样式，以及一个可以阅读和修改的小型后端。',
  'Your child designs an AI chatbot: they write the rules that steer how it talks, test it and share it with a Stars budget you approve.':
    '孩子设计一个 AI 聊天机器人：自己编写控制它说话方式的规则，测试后在你批准的星星额度内分享。',
  'Your child draws first, then uses AI to bring their own picture to life.':
    '孩子先自己画画，再用 AI 让自己的画“活”起来。',
  'Your child builds a song track by track, plays it back, and records their own mix.':
    '孩子一轨一轨地搭建歌曲，回放试听，并录制自己的混音。',
  'Turn writing into spoken audio with a choice of voices.': '把文字变成语音，可选择不同的声音。',
  'Your child plans a film before generating: story, visual references, storyboard, shots and edit decisions.':
    '孩子在生成前先规划影片：故事、视觉参考、分镜、镜头和剪辑决定。',
  'Program an animated story with snap-together blocks. No typing!':
    '用拼接积木给动画故事编程，无需打字！',
  'Vibe-code a 2D game — or a real website — with AI and real JavaScript, then keep adding to it.':
    '用 AI 和真实的 JavaScript 以“氛围编程”做出 2D 游戏或真正的网站，并不断扩展。',
  'Build a real website with pages AND its own little backend.':
    '搭建一个有页面、也有自己小型后端的真实网站。',
  'Build your own AI chatbot — write its personality, then chat with it.':
    '做一个自己的 AI 聊天机器人：写下它的性格，再和它聊天。',
  'Draw your own picture, then let AI bring it to life.':
    '先画出你自己的画，再让 AI 让它“活”起来。',
  'Compose a song on a real stage, then record it for real.': '在真实的舞台上作曲，再把它录下来。',
  'Turn text into spoken audio. Many voices.': '把文字变成语音，有多种声音可选。',
  'Plan the story, lock characters and locations, direct each shot, compare takes, then edit your film.':
    '规划故事，锁定角色和场景，导演每个镜头，对比不同版本，最后剪辑你的影片。',
  'Ages 5–8 who enjoy stories and are not ready to type code.':
    '喜欢故事、还不适合敲代码的 5–8 岁孩子。',
  'A playable animated story scene they can replay and explain.':
    '一个可以反复播放并讲解的动画故事场景。',
  'Choose a story chapter and meet the character who needs help.':
    '选一个故事章节，认识需要帮助的角色。',
  'Put colourful blocks in order to control what the character says and does.':
    '把彩色积木按顺序排好，控制角色说什么、做什么。',
  'Press Go, watch the result, then change one block and try again.':
    '按下“开始”，观察结果，再改动一块积木重新试试。',
  Sequencing: '顺序编排',
  Events: '事件',
  'Cause and effect': '因果关系',
  'Story logic': '故事逻辑',
  'There is no AI chat. Arranging blocks, playing and saving are free.':
    '没有 AI 聊天。拼积木、播放和保存都是免费的。',
  'What did you change, and what happened differently?': '你改了什么？结果有什么不同？',
  'Story Blocks studio showing the Stone Monkey on Flower-Fruit Mountain above colourful snap-together blocks.':
    'Story Blocks 创作空间：花果山上的石猴，下方是彩色的拼接积木。',
  'Try the real Journey to the West workspace: press Go, tap characters and change the picture blocks yourself.':
    '试试真实的《西游记》工作区：按下“开始”，点击角色，亲手改动图形积木。',
  'Playable family demo': '可玩的家庭体验版',
  'Meet the Monkey King. Make the story happen.': '认识美猴王，让故事动起来。',
  'Open the same Story Blocks workspace children use, then play, tap and change a three-page Monkey King adventure.':
    '打开孩子们使用的同一个 Story Blocks 工作区，玩一玩、点一点、改一改这个三页的美猴王冒险。',
  'Press Go': '按下“开始”',
  'Watch the Stone Monkey appear, hop, speak and wake his friends.':
    '看石猴出现、蹦跳、说话，并唤醒他的朋友们。',
  Tap: '点击',
  'Tap the Monkey and Water Curtain to trigger events and turn the page.':
    '点击猴子和水帘，触发事件并翻页。',
  'Change a block': '改动积木',
  'Change a number or move a block, then run the story again to see the difference.':
    '改一个数字或移动一块积木，再运行故事，看看有什么不同。',
  'Visit all three pages, from Flower-Fruit Mountain to the Monkey King’s raft.':
    '走遍全部三页，从花果山到美猴王的木筏。',
  'Family sampler: The Monkey King’s First Journey, ready to play now.':
    '家庭体验篇：《美猴王的第一次旅程》，现在就能玩。',
  'The demo is free, needs no sign-in or Stars, saves nothing and resets when you reopen it.':
    '体验免费，无需登录或星星，不保存任何内容，重新打开时会重置。',
  'Ages 8–14 with ideas for games, websites or interactive projects, including coding beginners.':
    '想做游戏、网站或互动项目的 8–14 岁孩子，编程新手也可以。',
  'A playable JavaScript creation they can test, change and keep improving.':
    '一个可玩的 JavaScript 作品，可以测试、修改并不断改进。',
  'Describe an idea in their own words and choose what the first version should do.':
    '用自己的话描述一个想法，并决定第一版要做什么。',
  'Play the creation, inspect the real JavaScript and check whether the AI got it right.':
    '玩一玩作品，查看真实的 JavaScript，检查 AI 做得对不对。',
  'Ask for one change at a time, test again and debug anything that breaks.':
    '一次只提一个修改，再次测试，并修复出错的地方。',
  'AI judgement': 'AI 判断力',
  JavaScript: 'JavaScript',
  Debugging: '调试',
  'Creative ownership': '创作主导权',
  'AI can build or change code, but your child makes the decisions and checks every result. AI actions show their Star cost before use; playing and manual code changes are free.':
    'AI 可以编写或修改代码，但由孩子做决定并检查每个结果。AI 操作会在使用前显示星星费用；玩作品和手动改代码是免费的。',
  'Show me one change you made and how it changed the creation.':
    '给我看看你做的一个改动，以及它怎样改变了作品。',
  'Creative Code Studio showing an AI conversation, JavaScript workspace and a running Fruit Catcher game.':
    'Creative Code Studio：AI 对话、JavaScript 工作区，以及一个正在运行的接水果游戏。',
  'The game runs beside the conversation and real code, so the child can test every change immediately.':
    '游戏就在对话和真实代码旁边运行，孩子可以立刻测试每个改动。',
  'Children who like drawing and want AI as a helper, not a replacement for their idea.':
    '喜欢画画、希望把 AI 当作帮手而不是替代自己想法的孩子。',
  'Their own drawing plus optional AI-assisted versions they can compare and refine.':
    '孩子自己的画，加上可选的 AI 辅助版本，可以对比并继续打磨。',
  'Start on the real canvas with brushes, colours and stickers.':
    '在真实画布上开始，使用画笔、颜色和贴纸。',
  'Ask the Coach for feedback or a faint guide only when help is wanted.':
    '需要帮助时，才向教练请教意见或要一条浅色参考线。',
  'Choose whether to bring the drawing to life, compare versions and keep improving it.':
    '自己决定是否让画“活”起来，对比不同版本并不断改进。',
  'Visual planning': '视觉规划',
  Drawing: '绘画',
  'Creative direction': '创意方向',
  'Comparing versions': '对比版本',
  'Drawing is free. AI is optional and only starts when your child presses a clearly priced Coach, guide or Bring it to life button.':
    '画画是免费的。AI 是可选的，只有孩子按下明码标价的“教练”“参考线”或“让它活起来”按钮时才会启动。',
  'Which parts did you make, and what did you ask AI to help with?':
    '哪些部分是你做的？你让 AI 帮了什么忙？',
  'Art Studio showing drawing tools, the canvas, optional AI Coach and clearly priced Stars actions.':
    'Art Studio：绘画工具、画布、可选的 AI 教练，以及明码标价的星星操作。',
  'The child draws on the canvas first; Coach and Bring it to life stay optional and show their Star cost.':
    '孩子先在画布上画；教练和“让它活起来”都是可选的，并会显示星星费用。',
  'Children who enjoy music, rhythm and mood, even if they have never learned an instrument.':
    '喜欢音乐、节奏和情绪的孩子，即使从没学过乐器也可以。',
  'A playable multi-track song they can remix, compare and record.':
    '一首可播放的多轨歌曲，可以重新混音、对比并录制。',
  'Describe a song idea and choose a musical genre.': '描述一个歌曲想法，并选择音乐风格。',
  'Hear the first arrangement, then explore the instruments and track lanes on the stage.':
    '听第一版编曲，再在舞台上探索各种乐器和音轨。',
  'Change the mood or sound, compare versions and record the mix they prefer.':
    '改变情绪或音色，对比版本，录下自己喜欢的混音。',
  'Musical structure': '音乐结构',
  'Mood and genre': '情绪与风格',
  Listening: '聆听',
  Iteration: '反复迭代',
  'Composing or re-generating music uses Stars and the cost is shown before the action. Playing, comparing and trying available instrument styles are free.':
    '作曲或重新生成音乐会消耗星星，操作前会显示费用。播放、对比和试用现有乐器风格是免费的。',
  'What did you change to make the song feel different?': '你改了什么，让这首歌听起来不一样了？',
  'Music Stage showing a live stage, instruments, song tracks and controls for changing the mix.':
    'Music Stage：现场舞台、乐器、歌曲音轨，以及调整混音的控件。',
  'The child can hear the song, inspect each instrument lane and choose which version to keep.':
    '孩子可以听歌、查看每条乐器音轨，并选择保留哪个版本。',
  'Copy family code {code}': '复制家庭代码 {code}',
  'Kids use this code with their nickname and PIN to sign in on the Kids login page.':
    '孩子在孩子登录页使用这个代码，加上自己的昵称和 PIN 登录。',
  'Kid carousel controls': '孩子卡片翻页控件',
  'Show previous kids': '显示上一批孩子',
  'Show more kids': '显示更多孩子',
  'Add kid': '添加孩子',
  Kids: '孩子',
  'Loading your kids…': '正在加载你的孩子…',
  "We couldn't load your kids": '无法加载你的孩子',
  'Your parent account is still available. Try loading the kids again.':
    '你的家长账户仍可正常使用。请重新加载孩子信息。',
  Retry: '重试',
  'Add your first kid': '添加第一个孩子',
  'Create their profile so they can sign in and start making.':
    '创建 TA 的档案，孩子就能登录并开始创作。',
  'Add your first kid →': '添加第一个孩子 →',
  'Age {age}': '{age} 岁',
  '{name} status: {status}': '{name} 的状态：{status}',
  'Signs in with email': '使用邮箱登录',
  'Login nickname: {name}': '登录昵称：{name}',
  "Opening {name}'s kids page…": '正在打开 {name} 的孩子页面…',
  "Open {name}'s profile": '打开 {name} 的资料',
  "Open {name}'s profile and PIN": '打开 {name} 的资料与 PIN',
  Profile: '资料',
  'Kids page access is paused. Use Profile to resume it.': '孩子页面访问已暂停。请在“资料”中恢复。',
  'Kids page access is paused. Use Profile & PIN to resume it.':
    '孩子页面访问已暂停。请在“资料与 PIN”中恢复。',
  "Could not open {name}'s kids page. Allow pop-ups and try again.":
    '无法打开 {name} 的孩子页面。请允许弹出窗口后重试。',
  'Awaiting confirmation': '等待确认',
  'Add {name} to calendar': '将 {name} 添加到日历',
  'Add to calendar': '添加到日历',
  'Calendar file downloaded.': '日历文件已下载。',
  'Request · {status}': '申请 · {status}',
  Received: '已收到',
  Contacted: '已联系',
  Confirmed: '已确认',
  Closed: '已关闭',
  'Course request': '课程申请',
  'Received — we will contact you within 1 business day.': '已收到，我们会在 1 个工作日内联系你。',
  'Our team has contacted you.': '我们的团队已联系你。',
  'Course confirmed.': '课程已确认。',
  'Closed.': '已关闭。',
  "{name}'s courses and requests": '{name} 的课程与申请',
  'Courses & requests': '课程与申请',
  '{count} current': '{count} 个进行中',
  'No current': '暂无进行中',
  '{count} past': '{count} 个已结束',
  'Courses are unavailable right now.': '课程暂时无法显示。',
  'No courses booked yet.': '还没有预约课程。',
  'Browse courses': '浏览课程',
  'Ready for the next course?': '准备好上下一门课了吗？',
  'Choose a new creative project for {name}.': '为 {name} 选一个新的创作项目。',
  'Past courses': '已结束的课程',
  '{count} completed': '已完成 {count} 个',
  'Update failed.': '更新失败。',
  'Reset failed.': '重置失败。',
  'Companion memories →': '伙伴记忆 →',
  'Kid profile': '孩子档案',
  'Kid profile not found': '找不到这个孩子档案',
  'We couldn’t load this kid profile': '无法加载这个孩子档案',
  'This profile may have been removed or the link may be out of date.':
    '这个档案可能已被移除，或链接已过期。',
  'No profile details are being shown as blank. Try loading it again.':
    '档案信息不会以空白显示。请重新加载。',
  'Trying again…': '重试中…',
  Kid: '孩子',
  'Not found': '未找到',
  '← Back': '← 返回',
  'Manage {name}': '管理 {name}',
  'Keep their identity, sign-in access and family details accurate.':
    '保持 TA 的身份、登录权限和家庭信息准确无误。',
  'Can sign in': '可以登录',
  'Sign-in paused': '登录已暂停',
  'Basic details': '基本信息',
  'These are the details your family sees when choosing the right child profile.':
    '你的家庭在选择孩子档案时会看到这些信息。',
  'Display nickname': '显示昵称',
  'Worked out from the birth month {name} gave when they signed up.':
    '根据 {name} 注册时填写的出生月份推算。',
  'Login nickname': '登录昵称',
  '{name} types this nickname with the family code and PIN.':
    '{name} 用这个昵称，加上家庭代码和 PIN 登录。',
  'Their look': 'TA 的形象',
  Avatar: '头像',
  'Pick something easy for {name} to recognise at sign-in.': '选一个方便 {name} 登录时认出的头像。',
  'Access & limits': '权限与限额',
  'Control whether this child can sign in and optionally set a lower daily Stars limit.':
    '控制孩子能否登录，也可以设置更低的每日星星上限。',
  'Daily Stars cap (optional)': '每日星星上限（选填）',
  'Leave empty to use family cap': '留空则使用家庭上限',
  'This can be lower than the family cap. Leave it empty to inherit the family setting.':
    '可以低于家庭上限。留空则沿用家庭设置。',
  'Active — kid can sign in': '启用，孩子可以登录',
  'Turn this off to pause new sessions. Their profile and growth history stay available.':
    '关闭后将暂停新的登录。TA 的档案和成长记录仍会保留。',
  'School is optional and helps match future course and local-program information.':
    '学校为选填，有助于匹配之后的课程和本地项目信息。',
  'Ready to save?': '准备保存了吗？',
  'Nickname, avatar, age, access, limits and school are saved together.':
    '昵称、头像、年龄、权限、限额和学校会一起保存。',
  'Save profile changes': '保存档案修改',
  Saved: '已保存',
  'Sign-in and safety settings': '登录与安全设置',
  'Sign-in': '登录',
  '{name} signed up with their own email and keeps signing in with it (an email code, or a password they set). There is no family code or PIN for them.':
    '{name} 用自己的邮箱注册，并继续用邮箱登录（邮箱验证码，或自己设置的密码）。TA 没有家庭代码或 PIN。',
  '{name} is linked to your family for good. If this link is a mistake, contact Airbotix support.':
    '{name} 已永久关联到你的家庭。如果关联有误，请联系 Airbotix 客服。',
  'Sign-in safety': '登录安全',
  'Set a new kid PIN': '设置新的孩子 PIN',
  "Use four digits the child can remember but other children cannot easily guess. Resetting it signs out all of this kid's devices.":
    '请使用孩子记得住、其他孩子不容易猜到的四位数字。重置后，这个孩子所有设备都会退出登录。',
  'Confirm PIN': '确认 PIN',
  'PIN updated': 'PIN 已更新',
  'Resetting…': '重置中…',
  'Reset PIN': '重置 PIN',
  'Need to remove this kid profile?': '需要移除这个孩子档案？',
  'Delete this kid': '删除这个孩子',
  'This signs the child out and soft-deletes the profile. An administrator can restore it within 30 days.':
    '这会让孩子退出登录，并对档案做软删除。管理员可在 30 天内恢复。',
  'Deleting…': '删除中…',
  Delete: '删除',
  'Confirm deletion of {name}': '确认删除 {name}',
  'Delete {name}? Their profile can be restored by an administrator for 30 days.':
    '删除 {name}？管理员可在 30 天内恢复 TA 的档案。',
  'Keep profile': '保留档案',
  'Confirm deletion': '确认删除',
  'We couldn’t delete this profile. Try again.': '无法删除这个档案，请重试。',
  'Login nickname cannot contain spaces': '登录昵称不能包含空格',
  'Enter the same 4-digit PIN': '请输入相同的 4 位 PIN',
  'PINs do not match': 'PIN 不一致',
  'Display nickname is required': '请填写显示昵称',
  'Use letters, numbers, apostrophes or hyphens': '只能使用字母、数字、撇号或连字符',
  'About your kid': '关于你的孩子',
  'Sign-in and limits': '登录与限额',
  'School and review': '学校与确认',
  'Set up your family first': '请先设置你的家庭',
  '{message} Your details are still here; update them or try again.':
    '{message} 你填写的信息仍在，请修改后重试。',
  'Could not add kid. Your details are still here; check your connection and try again.':
    '无法添加孩子。你填写的信息仍在，请检查网络后重试。',
  'A new': '添加一位新',
  kid: '孩子',
  'Up to 5 kids per family. PINs are private — kids type them at sign in.':
    '每个家庭最多 5 个孩子。PIN 是保密的，孩子登录时自己输入。',
  'How to add the kid': '添加孩子的方式',
  'New kid': '新建孩子',
  'I have a kid code': '我有孩子代码',
  'Your child types this at sign-in. Leave it blank to use {name}.':
    '孩子登录时输入这个昵称。留空则使用 {name}。',
  'their first name': 'TA 的名字',
  'Loading avatar choices…': '正在加载头像选项…',
  'Could not load existing kid profiles': '无法加载已有的孩子档案',
  'Try again before you choose an avatar and add this kid.': '请先重试，再选择头像并添加这个孩子。',
  '4-digit PIN': '4 位 PIN',
  'leave empty to inherit family cap': '留空则沿用家庭上限',
  'Ready to add {name}?': '准备好添加 {name} 了吗？',
  'your kid': '你的孩子',
  'Age {age} · School {school}': '{age} 岁 · 学校：{school}',
  'Not provided': '未填写',
  'Your PIN stays private and is not shown here.': 'PIN 会保密，不会在这里显示。',
  'Adding…': '添加中…',
  'Add kid →': '添加孩子 →',
  'Continue →': '继续 →',
  Cancel: '取消',
  'Extra Stars': '额外星星',
  'Public share': '公开分享',
  'Always-allow tool': '始终允许的工具',
  'Add kid profile': '添加孩子档案',
  'Topic limit change': '话题限制变更',
  'Other request': '其他请求',
  pending: '待处理',
  granted: '已批准',
  denied: '已拒绝',
  expired: '已过期',
  'Approval requests': '审批请求',
  'Could not load approval requests': '无法加载审批请求',
  'No decision status has been assumed. Try loading the requests again.':
    '不会擅自假定任何审批结果。请重新加载请求。',
  'All caught up': '全部处理完毕',
  'No approval requests are waiting.': '没有等待审批的请求。',
  'Child profile unavailable': '孩子档案不可用',
  'Recent decisions': '近期审批结果',
  'Could not load course requests': '无法加载课程申请',
  'Course requests': '课程申请',
  'We received your request and will contact you within 1 business day.':
    '我们已收到你的申请，会在 1 个工作日内联系你。',
  'Our team has contacted you about this request.': '我们的团队已就这项申请联系了你。',
  'Your requested course is confirmed.': '你申请的课程已确认。',
  'This request is closed.': '这项申请已关闭。',
  'Could not grant.': '无法批准。',
  'Could not deny.': '无法拒绝。',
  'For {name}': '针对 {name}',
  Grant: '批准',
  Deny: '拒绝',
  'Game share links': '游戏分享链接',
  'Loading share links…': '正在加载分享链接…',
  'Could not load game share links': '无法加载游戏分享链接',
  'Try again before you review or manage public links.': '请先重试，再查看或管理公开链接。',
  'Parent controls': '家长控制',
  'Students create these links directly. You receive the project details and link here, can see how many people played it, and can turn it off at any time.':
    '这些链接由学生直接创建。你会在这里收到项目详情和链接，可以看到有多少人玩过，也可以随时关闭。',
  'Family project': '家庭项目',
  'link is on': '链接已开启',
  'People can copy the game to their own account. Turning this off stops new copies — the link keeps playing.':
    '别人可以把游戏复制到自己的账户。关闭后将不再允许新的复制，链接仍可继续游玩。',
  'Visitor Stars: {spent} of {total}★ used': '访客星星：已用 {spent} / {total}★',
  'visitors paused': '访客已暂停',
  'New visitor Stars budget': '新的访客星星额度',
  'Set budget': '设置额度',
  'Pause visitors': '暂停访客',
  'Raising the total lets visitors keep chatting; 0 pauses them. The page still opens.':
    '调高总额可让访客继续聊天；设为 0 则暂停访客。页面仍可打开。',
  '1 play': '1 次游玩',
  '{count} plays': '{count} 次游玩',
  Copy: '复制',
  'Created {time}': '创建于 {time}',
  'Turn off link': '关闭链接',
  'Stops playing and remixing': '停止游玩和改编',
  'Allow remixing': '允许改编',
  'Needs {amount} extra Stars for {reason}': '需要 {amount} 颗额外星星，用于{reason}',
  'Needs {amount} extra Stars': '需要 {amount} 颗额外星星',
  'Needs extra Stars for {reason}': '需要额外星星，用于{reason}',
  'Needs extra Stars': '需要额外星星',
  'Wants to share “{title}” publicly': '想要公开分享“{title}”',
  'Wants to share a project publicly': '想要公开分享一个项目',
  'Wants to always allow {command}': '想要始终允许 {command}',
  'Wants to always allow a tool': '想要始终允许某个工具',
  'Wants to add the kid profile {name}': '想要添加孩子档案 {name}',
  'Wants to add a kid profile': '想要添加一个孩子档案',
  'Wants the “{topic}” topic limit changed': '想要更改“{topic}”的话题限制',
  'Wants a topic limit changed': '想要更改话题限制',
  'Review this request before you choose an action.': '请先查看这项请求，再决定如何处理。',
  '1 Star': '1 颗星星',
  'an Airbotix page': 'Airbotix 的某个页面',
  Classes: '班级',
  Teachers: '老师',
  Academy: 'Academy',
  Approvals: '审批',
  Activity: '活动',
  Create: '创作',
  Classroom: '课堂',
  'AI Studio': 'AI Studio',
  Lessons: '课节',
  'Image Studio': 'Image Studio',
  'Music Studio': 'Music Studio',
  'Code Studio': 'Code Studio',
  'AI helper': 'AI 助手',
  You: '你',
  Teacher: '老师',
  Airbotix: 'Airbotix',
  System: '系统',
  'Parent Portal opened': '打开了家长中心',
  'Airbotix opened': '打开了 Airbotix',
  'Opened {target}': '打开了{target}',
  'Top-up started': '开始充值',
  'Stars added to your wallet': '星星已存入你的钱包',
  "Top-up didn't go through": '充值未成功',
  'No Stars were charged': '没有扣除星星',
  'Refunded to your wallet': '已退回钱包',
  'Spending limits updated': '消费限额已更新',
  'Wallet paused': '钱包已暂停',
  'AI spending is on hold': 'AI 消费已暂停',
  'Wallet resumed': '钱包已恢复',
  'AI spending is back on': 'AI 消费已恢复',
  'Wallet adjusted by Airbotix': 'Airbotix 调整了钱包',
  'Adding a payment method': '正在添加支付方式',
  'Payment method added': '已添加支付方式',
  'Default card updated': '默认银行卡已更新',
  'Payment method removed': '已移除支付方式',
  'Auto top-up updated': '自动充值已更新',
  'Turned on': '已开启',
  'Turned off': '已关闭',
  'Your child asked for permission': '你的孩子申请了权限',
  'You approved a request': '你批准了一项请求',
  'You declined a request': '你拒绝了一项请求',
  'New project created': '新建了项目',
  'Project updated': '项目已更新',
  'Project deleted': '项目已删除',
  'File added to a project': '项目中添加了文件',
  'Asked to share a project': '申请分享项目',
  'Teacher reviewed a share request': '老师审核了分享申请',
  'You reviewed a share request': '你审核了分享申请',
  'Your child signed in': '你的孩子已登录',
  'Failed sign-in attempt': '登录尝试失败',
  "Your child's sign-in was locked": '你孩子的登录已被锁定',
  'Too many attempts — try again later': '尝试次数过多，请稍后再试',
  'Joined a class': '加入了班级',
  'Left a class': '退出了班级',
  'Saved code changes': '保存了代码修改',
  '{count} files': '{count} 个文件',
  'A note was added': '添加了一条备注',
  'You exported your data': '你导出了数据',
  'An issue was flagged': '有问题被标记',
  'An issue was resolved': '有问题已解决',
  text: '文字',
  'an image': '图片',
  music: '音乐',
  'a voice clip': '语音片段',
  'a video': '视频',
  content: '内容',
  "AI couldn't make {noun}": 'AI 无法生成{noun}',
  'AI helped make {noun}': 'AI 帮忙生成了{noun}',
  'Filtered phrase detected': '检测到被过滤的词句',
  'A blocked word or phrase was caught before sending.': '发送前拦截了一个被屏蔽的词或短语。',
  'Topic not allowed': '话题不被允许',
  'Topic: {topic}': '话题：{topic}',
  'This topic is outside the allowed list.': '这个话题不在允许的范围内。',
  'Prompt injection blocked': '已拦截提示词注入',
  'An attempt to override AI rules was blocked.': '已拦截试图绕过 AI 规则的尝试。',
  'Safety filter stepped in': '安全过滤已介入',
  'Content was checked and adjusted.': '内容已被检查并调整。',
  'Personal info protected': '个人信息已受保护',
  'Detected: {categories}': '检测到：{categories}',
  'Private information was caught and protected.': '私人信息已被拦截并保护。',
  'Personal info notice sent': '已发送个人信息提醒',
  'A caution about sharing personal details was shown.': '已显示分享个人信息的提醒。',
  'Chose to continue after caution': '看到提醒后选择继续',
  'Your child acknowledged the personal info notice and continued.':
    '你的孩子已确认个人信息提醒并继续。',
  'Repeated safety triggers': '反复触发安全规则',
  'Multiple safety events happened in a short period. A teacher was notified.':
    '短时间内发生了多次安全事件，已通知老师。',
  'Made a safer choice': '做出了更安全的选择',
  'Your child stopped before sending a flagged message.': '你的孩子在发送被标记的消息前停下了。',
  'AI response filtered': 'AI 回复已被过滤',
  "The AI's response was blocked before your child saw it.": 'AI 的回复在孩子看到之前已被拦截。',
  'AI response adjusted': 'AI 回复已调整',
  "Part of the AI's response was removed before your child saw it.":
    'AI 回复的一部分在孩子看到之前已被移除。',
  'Safety check passed': '安全检查通过',
  'Activity recorded': '已记录活动',
  'Loading your family activity…': '正在加载你的家庭活动…',
  'Could not load your family': '无法加载你的家庭',
  'We could not confirm which activity belongs to your family. Try again.':
    '无法确认哪些活动属于你的家庭，请重试。',
  'Family activity will appear after you add your family details.':
    '添加家庭信息后，这里会显示家庭活动。',
  'Start setup': '开始设置',
  'Your family’s activity': '你的家庭活动',
  'Review account, project, AI, and safety activity, newest first. Private prompts and technical details stay hidden.':
    '按时间从新到旧查看账户、项目、AI 和安全相关活动。私密提示词和技术细节不会显示。',
  'Kid names are temporarily unavailable': '暂时无法显示孩子的名字',
  'Activity is still complete. Kid entries use a general label until names reload.':
    '活动记录仍然完整。名字重新加载前，孩子的记录会使用通用称呼。',
  'Loading family activity…': '正在加载家庭活动…',
  'Could not load family activity': '无法加载家庭活动',
  'Your activity is still saved. Try loading it again.': '你的活动记录仍已保存。请重新加载。',
  'No family activity yet': '还没有家庭活动',
  'Top-ups, project changes, AI help, approvals, and safety updates will appear here.':
    '充值、项目变更、AI 协助、审批和安全更新会显示在这里。',
  'Check again': '再检查一次',
  'Checking…': '检查中…',
  'Reloading names…': '正在重新加载名字…',
  'Reload kid names': '重新加载孩子名字',
  'Activity timeline': '活动时间线',
  'Show fewer activities': '收起部分活动',
  'Show all {count} activities': '显示全部 {count} 条活动',
  'Hide safety summary': '收起安全摘要',
  'See safety summary': '查看安全摘要',
  'Loading safety summary…': '正在加载安全摘要…',
  'Could not load the safety summary.': '无法加载安全摘要。',
  'No recent safety details are available.': '暂无近期安全详情。',
  '1 block in the last {minutes} minutes': '最近 {minutes} 分钟内拦截 1 次',
  '{count} blocks in the last {minutes} minutes': '最近 {minutes} 分钟内拦截 {count} 次',
  'How to talk to your child': '如何与孩子沟通',
  'Project activity link is incomplete': '项目活动链接不完整',
  'Return to Notifications and open the project alert again.': '请返回通知，重新打开项目提醒。',
  '{name}’s project': '{name} 的项目',
  'Your project': '你的项目',
  'Review key project actions and Stars, newest first. Prompt text, AI provider details, and private file locations stay hidden.':
    '按时间从新到旧查看项目的关键操作和星星使用。提示词内容、AI 服务商详情和私有文件位置不会显示。',
  'Loading project details…': '正在加载项目详情…',
  'Project name is unavailable': '暂时无法显示项目名称',
  'You can still review the saved activity below. The project may have been deleted.':
    '下方仍可查看已保存的活动。该项目可能已被删除。',
  'Reloading details…': '正在重新加载详情…',
  'Retry project details': '重新加载项目详情',
  'Loading filmmaking summary': '正在加载影片制作摘要',
  'Loading filmmaking summary…': '正在加载影片制作摘要…',
  'Could not load the filmmaking summary': '无法加载影片制作摘要',
  'Project activity is still available below.': '下方仍可查看项目活动。',
  'Retry summary': '重新加载摘要',
  'Story beats': '故事节点',
  'Visual elements': '视觉元素',
  Shots: '镜头',
  'Board approvals': '分镜确认数',
  'AI filmmaking process': 'AI 影片制作过程',
  'Current stage: {stage}': '当前阶段：{stage}',
  'Not available': '不可用',
  '{count} Stars used': '已使用 {count} 颗星星',
  'for confirmed AI creation. Export used {count} Stars.':
    '用于已确认的 AI 创作。导出使用了 {count} 颗星星。',
  'What your child said': '你的孩子说了什么',
  'Teacher feedback': '老师反馈',
  'This parent summary keeps prompt text, AI provider details, and private file locations hidden.':
    '这份家长摘要不会显示提示词内容、AI 服务商详情和私有文件位置。',
  'No project activity yet': '还没有项目活动',
  'Saved changes, AI help, Stars, and sharing decisions will appear here.':
    '保存的修改、AI 协助、星星使用和分享决定会显示在这里。',
  'Loading project activity…': '正在加载项目活动…',
  'Could not load project activity': '无法加载项目活动',
  'The project is unchanged. Try loading its activity again.': '项目没有变化。请重新加载其活动。',
  'Untitled picture': '未命名的画',
  'Open {title}': '打开 {title}',
  'Loading picture': '正在加载图片',
  'Picture unavailable': '图片无法显示',
  'Picture details': '图片详情',
  'Close picture details': '关闭图片详情',
  'This picture could not be loaded.': '无法加载这张图片。',
  Close: '关闭',
  "We couldn't load your kid's name just now — the pictures below are still theirs.":
    '暂时无法加载孩子的名字，但下方的画仍是 TA 的作品。',
  '{name}’s pictures': '{name} 的画',
  'Showing the latest {limit} pictures · {stars}★ spent on these':
    '显示最新 {limit} 张画 · 共花费 {stars}★',
  '1 picture · {stars}★ spent': '1 张画 · 花费 {stars}★',
  '{count} pictures · {stars}★ spent': '{count} 张画 · 花费 {stars}★',
  'Last created {time}': '最近创作于 {time}',
  'Export prompts': '导出提示词',
  "Loading {name}'s pictures…": '正在加载 {name} 的画…',
  "We couldn't load {name}'s pictures.": '无法加载 {name} 的画。',
  'No pictures yet': '还没有画作',
  "When {name} paints or makes magic pictures in the Art Studio, they'll appear here for you to enjoy — prompts, stars and all.":
    '{name} 在 Art Studio 里画画或制作魔法图片后，作品会显示在这里供你欣赏，包括提示词和星星使用情况。',
  Today: '今天',
  'This week': '本周',
  Earlier: '更早',
  '{count} need action': '{count} 项待处理',
  'Notification views': '通知视图',
  All: '全部',
  'Needs action': '待处理',
  Action: '待处理',
  Updates: '更新',
  'Family member': '家庭成员',
  'Filter notifications by family member': '按家庭成员筛选通知',
  'All family': '全部家庭成员',
  'Some updates could not load': '部分更新无法加载',
  '{sources} remain unavailable. The notifications shown below are still current.':
    '{sources}仍无法加载。下方显示的通知仍是最新的。',
  'Nothing in this view': '此视图中没有内容',
  'Choose another family member or notification filter.': '请选择其他家庭成员或通知筛选条件。',
  'Show every notification type ({count})': '显示所有类型的通知（{count}）',
  'Show fewer notifications': '收起部分通知',
  'Notification details': '通知详情',
  'Back to notifications': '返回通知列表',
  'Choose an update': '选择一条更新',
  'Details and available actions open here.': '详情和可用操作会在这里打开。',
  'Newest first': '最新在前',
  'Loading notifications': '正在加载通知',
  'No requests need a decision. Course, report and wallet updates will appear here.':
    '没有需要你决定的请求。课程、报告和钱包的更新会显示在这里。',
  Recently: '刚刚',
  'Public project share': '公开项目分享',
  Granted: '已批准',
  Denied: '已拒绝',
  Expired: '已过期',
  'approval requests': '审批请求',
  'family members': '家庭成员',
  'course updates': '课程更新',
  'game-share links': '游戏分享链接',
  'wallet updates': '钱包更新',
  'learning summaries': '学习摘要',
  'Family wallet': '家庭钱包',
  'Family billing': '家庭账单',
  'Link on': '链接已开启',
  Booked: '已预约',
  Reminder: '提醒',
  Completed: '已完成',
  Refunded: '已退款',
  Summary: '摘要',
  '{name} shared {title}': '{name} 分享了 {title}',
  'The link is active with 1 play. Review its details or turn it off here.':
    '链接已开启，有 1 次游玩。可在这里查看详情或关闭链接。',
  'The link is active with {count} plays. Review its details or turn it off here.':
    '链接已开启，有 {count} 次游玩。可在这里查看详情或关闭链接。',
  'Finish booking {name}': '完成 {name} 的预约',
  'Payment is still open; the seat is not locked.': '付款尚未完成，名额还没有锁定。',
  Course: '课程',
  Amount: '金额',
  Seat: '名额',
  'Not locked yet': '尚未锁定',
  'We received your {course} request': '我们已收到你的 {course} 申请',
  'We contacted you about {course}': '我们已就 {course} 联系了你',
  'Your {course} request is confirmed': '你的 {course} 申请已确认',
  'Your {course} request is closed': '你的 {course} 申请已关闭',
  'Our team will contact you within one business day.': '我们的团队会在 1 个工作日内联系你。',
  'Check the message from the course team.': '请查看课程团队发来的消息。',
  'The confirmed course is available on Home.': '已确认的课程可在首页查看。',
  'No course was created from this request.': '这项申请没有生成课程。',
  Status: '状态',
  For: '对象',
  '{name}’s {course} seat is locked': '{name} 的 {course} 名额已锁定',
  '{course} starts soon': '{course} 即将开始',
  'Check the time, venue and {name}’s sign-in details before leaving home.':
    '出门前请确认时间、地点以及 {name} 的登录信息。',
  'Your balance is below {count} Stars': '你的余额低于 {count} 颗星星',
  'Top up now or enable auto top-up before the next project.':
    '请现在充值，或在下一个项目前开启自动充值。',
  Available: '可用',
  'Low-balance level': '低余额提醒线',
  On: '开',
  Off: '关',
  'Set auto top-up': '设置自动充值',
  'We could not complete an auto top-up': '自动充值未能完成',
  'The saved card': '已保存的银行卡',
  '{card} was declined.': '{card} 被拒绝。',
  Attempt: '尝试',
  Card: '银行卡',
  'Saved card': '已保存的银行卡',
  Result: '结果',
  Declined: '已拒绝',
  'Change card': '更换银行卡',
  'Open auto top-up': '打开自动充值',
  'Auto top-up safety limit reached': '已达到自动充值安全限额',
  'Automatic top-ups are paused by your configured spending limit.':
    '自动充值已因你设置的消费限额而暂停。',
  Reason: '原因',
  'Safety limit': '安全限额',
  'Charge made': '是否已扣款',
  No: '否',
  'View wallet limits': '查看钱包限额',
  '{stars} Stars were added': '已存入 {stars} 颗星星',
  'Auto top-up completed': '自动充值已完成',
  '{amount} was charged to {card}.': '已从 {card} 扣款 {amount}。',
  'your saved card': '你已保存的银行卡',
  Added: '已存入',
  'Stars pack': '星星套餐',
  Charged: '已扣款',
  'View receipt': '查看收据',
  'Auto top-up has been paused': '自动充值已暂停',
  '{count} consecutive attempts failed.': '连续 {count} 次尝试失败。',
  'Consecutive failures': '连续失败',
  Failures: '失败次数',
  'Current state': '当前状态',
  'Fix auto top-up': '修复自动充值',
  'View billing': '查看账单',
  '+{count} Stars': '+{count} 颗星星',
  '{stars} were added to your family wallet.': '{stars}已存入你的家庭钱包。',
  Reward: '奖励',
  'Balance after': '变动后余额',
  'View rewards': '查看奖励',
  '{name} completed a creative mission': '{name} 完成了一个创作任务',
  '{count} Stars were added as a mission reward.': '{count} 颗星星已作为任务奖励存入。',
  'Saved activity': '已保存的活动',
  'Open project activity': '打开项目活动',
  'View activity': '查看活动',
  'Your {amount} refund is complete': '你的 {amount} 退款已完成',
  'Your refund is complete': '你的退款已完成',
  'The refund and related Stars adjustment are available in Billing.':
    '退款及相关的星星调整可在账单中查看。',
  'See billing': '请查看账单',
  'Stars adjustment': '星星调整',
  'Your family had 1 active session this week': '本周你的家庭有 1 次活跃学习',
  'Your family had {count} active sessions this week': '本周你的家庭有 {count} 次活跃学习',
  '{stars} Stars used across {requests} learning requests.':
    '共使用 {stars} 颗星星，涉及 {requests} 次学习请求。',
  'Active sessions': '活跃学习次数',
  'Learning requests': '学习请求次数',
  'Stars used': '星星使用量',
  'View family': '查看家庭',
  'Could not grant this request.': '无法批准这项请求。',
  'Could not deny this request.': '无法拒绝这项请求。',
  'Could not open this request.': '无法打开这项请求。',
  'Add profile': '添加档案',
  'Declining…': '正在拒绝…',
  Decline: '拒绝',
  'Could not update the link.': '无法更新链接。',
  'Could not update remixing.': '无法更新改编设置。',
  'Project type': '项目类型',
  project: '项目',
  'Link access': '链接访问权限',
  'Anyone with the link': '任何有链接的人',
  Plays: '游玩次数',
  'Visitor Stars': '访客星星',
  '{spent} of {total}★ used': '已用 {spent} / {total}★',
  'Public project link': '公开项目链接',
  'Turning off…': '正在关闭…',
  Starts: '开始时间',
  Venue: '地点',
  'Check sign-in details': '检查登录信息',
  'Prepare {name}': '为 {name} 做准备',
  Request: '请求',
  Requested: '申请数量',
  Expires: '到期时间',
  Access: '访问权限',
  Public: '公开',
  Tool: '工具',
  Duration: '时长',
  'Until changed': '直到更改',
  'Needs about': '大约还需要',
  '{count} more Stars': '还需 {count} 颗星星',
  Topic: '话题',
  '{name} needs {amount} extra Stars': '{name} 需要 {amount} 颗额外星星',
  '{name} needs extra Stars': '{name} 需要额外星星',
  'Review the request before deciding.': '请先查看请求，再做决定。',
  '{name} wants to share {title} publicly': '{name} 想要公开分享 {title}',
  '{name} wants to share a project publicly': '{name} 想要公开分享一个项目',
  'Review the project before you decide.': '请先查看项目，再做决定。',
  '{name} wants to always allow {tool}': '{name} 想要始终允许 {tool}',
  '{name} wants to always allow a tool': '{name} 想要始终允许某个工具',
  'The tool would stop asking each time.': '该工具以后不会再每次询问。',
  'Review a new kid profile': '请查看新的孩子档案',
  'A profile named {name} is ready to add.': '名为 {name} 的档案已准备好添加。',
  'Check the profile before adding it.': '添加前请先查看档案。',
  '{name} is out of Stars': '{name} 的星星用完了',
  'Top up the family wallet so they can keep building.': '请为家庭钱包充值，TA 才能继续创作。',
  '{name} wants a topic limit changed': '{name} 想要更改话题限制',
  'Review the request for {topic}.': '请查看关于“{topic}”的请求。',
  'This changes an ongoing content control.': '这会更改一项持续生效的内容控制。',
  '{name} has a request': '{name} 有一项请求',
  'Review this request before choosing an action.': '请先查看这项请求，再决定如何处理。',
  'Student memory': '学生记忆',
  'Personal memory follows the Airbotix account across Hangar computers. It does not change grades or Stars.':
    '个人记忆会跟随 Airbotix 账户，在不同的 Hangar 电脑上通用。它不会影响成绩或星星。',
  'Loading memory…': '正在加载记忆…',
  'Could not load memory.': '无法加载记忆。',
  'Could not save memory.': '无法保存记忆。',
  'Retry saved change': '重试已保存的修改',
  'Review cloud version': '查看云端版本',
  'Cloud sync enabled': '云同步已开启',
  'Cloud sync paused': '云同步已暂停',
  'Cloud sync is not yet available': '云同步暂不可用',
  'Pause cloud sync': '暂停云同步',
  'Enable cloud sync': '开启云同步',
  'Pausing stops new uploads. Existing cloud memories remain until you delete them.':
    '暂停后不再上传新内容。已有的云端记忆会保留，直到你删除。',
  'Delete every saved cloud memory item for this account?':
    '要删除这个账户已保存的所有云端记忆吗？',
  'Confirm deletion of all cloud memory': '确认删除全部云端记忆',
  'Cancel deletion': '取消删除',
  'Delete all cloud memory': '删除全部云端记忆',
  'Your parent updated {count} memory item(s). Review the parent corrections below.':
    '家长更新了 {count} 条记忆。请查看下方家长的修正。',
  'I have reviewed these updates': '我已查看这些更新',
  'No saved memory yet.': '还没有保存的记忆。',
  'Source: {source} · {status} · {sharing}': '来源：{source} · {status} · {sharing}',
  'Parent correction': '家长修正',
  'Account owner': '账户所有者',
  'Awaiting confirmation; excluded from AI': '等待确认，不会提供给 AI',
  'Confirmed; available to AI when sync is enabled': '已确认，开启同步后可提供给 AI',
  'Shared with {count} family member(s)': '已与 {count} 位家庭成员分享',
  Private: '私密',
  'Updated: {time}': '更新于：{time}',
  'Why this memory may be used': '这条记忆为什么可能被使用',
  'This suggestion is waiting for confirmation and is excluded from AI context.':
    '这条建议正在等待确认，不会提供给 AI。',
  'Cloud memory is paused or unavailable, so this account’s memory is excluded from the helper.':
    '云端记忆已暂停或不可用，因此这个账户的记忆不会提供给助手。',
  'This confirmed memory belongs to the selected account. The helper may use it to continue learning, subject to privacy and safety checks. It is not necessarily used in every reply.':
    '这条已确认的记忆属于所选账户。助手可能会用它来延续学习，并遵守隐私和安全检查。不一定每次回复都会用到。',
  'Confirm memory': '确认记忆',
  'Delete memory': '删除记忆',
  'Edit memory': '编辑记忆',
  'Shared family memory': '家庭共享记忆',
  'Shared with you': '与你分享的记忆',
  'Confirmed family memory. The owner controls sharing and correction.':
    '已确认的家庭记忆。由所有者控制分享和修正。',
  'Deletion status could not be loaded.': '无法加载删除状态。',
  'Cloud deletion status': '云端删除状态',
  '{count} memory item(s) removed from cloud storage · {status}':
    '已从云端存储移除 {count} 条记忆 · {status}',
  'Backup provider verified completion': '备份服务商已确认完成',
  'Backup provider handling pending': '备份服务商处理中',
  'Backup provider handling needs review': '备份服务商处理需要复核',
  'Operator backup evidence recorded': '已记录运营方的备份证明',
  'Backup handling pending': '备份处理中',
  'Recent helper context': '助手近期使用的上下文',
  'These memory items were provided with recent helper requests. The helper may not mention or adopt them. Current item versions are shown below and may have changed since the request. An interrupted reply can still be refunded.':
    '这些记忆条目随最近的助手请求一并提供。助手不一定会提及或采用它们。下方显示的是条目的当前版本，可能与请求时不同。被中断的回复仍可退款。',
  'Loading recent context…': '正在加载近期上下文…',
  'Recent helper context could not be loaded.': '无法加载助手近期使用的上下文。',
  'No saved-memory context receipts yet.': '还没有已保存记忆的使用记录。',
  '{time} · {count} memory item(s)': '{time} · {count} 条记忆',
  'Current item: {text}': '当前条目：{text}',
  'A previous memory item that is now removed or unavailable.':
    '一条之前的记忆，现已被移除或不可用。',
  'Correct memory': '修正记忆',
  'Remember this': '记住这件事',
  'Save an AI suggestion for review before use': '先保存为 AI 建议，使用前需经审核',
  'Share this memory with': '将这条记忆分享给',
  'Only selected family members receive confirmed memory. Clear every selection to make it private.':
    '只有选中的家庭成员会收到已确认的记忆。取消所有选择即可设为私密。',
  'Family recipients could not be loaded. Sharing cannot be changed.':
    '无法加载家庭成员名单，因此无法更改分享设置。',
  'Save correction': '保存修正',
  'Save memory': '保存记忆',
  'Cancel correction': '取消修正',
};
